import Vue from 'vue';
import Vuex from 'vuex';
import { createProxy, extractVuexModule } from 'vuex-class-component';
import BillingStore from './BillingStore';
import InitialStateStore from './InitialStateStore';
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
Vue.use(Vuex);
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
const store = (new Vuex.Store({
    modules: Object.assign(Object.assign({}, extractVuexModule(BillingStore)), extractVuexModule(InitialStateStore)),
}));
export default store;
export const vxm = {
    initialState: createProxy(store, InitialStateStore),
    billing: createProxy(store, BillingStore),
};
